<script>
  import { filteredStories, colorCriterium, colorScheme } from './stores.js'

  export let attributeName = ''
  export let attributeValues = []
  export let selectedAttributeValues = []

  $: counts = {}

  $: {
    attributeValues.forEach(v => {
      counts[v] = $filteredStories.filter(s => s[attributeName] == v).length
    })
  }

  function handleClick(value) {
    const index = selectedAttributeValues.indexOf(value)
    if (index == -1) {
      selectedAttributeValues = [...selectedAttributeValues, value]
    } else {
      selectedAttributeValues.splice(index, 1)
      selectedAttributeValues = selectedAttributeValues
    }
  }
</script>

<style>
  .background {
    background-color: #101c2ddd;

  }
  .color-box {
    width: 10px;
    height: 10px;
    display: inline-block;
  }
  .button {
    margin: 1px 5px;
    cursor: pointer;
    color: #aaaaaa;
    display: inline-block;
  }
  .button:hover {
    text-decoration: underline;
    user-select: none;
  }
  .button.selected {
    text-decoration: underline;
    color: #ffffff;
  }
  .label {
    margin: 5px;
    color: #aaaaaa;
    user-select: none;
    cursor: pointer;
  }
  .label.selected {
    text-decoration: underline;
    color: #ffffff;
  }
  .count {
    display: inline-block;
    color: #aaaaaa;
    font-size: 0.7em;
  }
  .menu-item:after {
    clear: both;
  }

</style>

<div class="background">
  <div
    class="label"
    class:selected="{$colorCriterium==attributeName}"
    on:click='{() => $colorCriterium = attributeName}'>
      { attributeName.toUpperCase() }
  </div>
  {#each attributeValues as value}
    <div class="menu-item">
      <div
        class="color-box"
        style="background-color:{$colorCriterium==attributeName ? $colorScheme[value] : 'transparent'}">
      </div>
      <div class="button"
        class:selected="{selectedAttributeValues.indexOf(value) != -1}"
        on:click='{() => handleClick(value)}'>
        {value}
      </div>
      <div class="count">
        { counts[value] }
      </div>
    </div>
  {/each}
</div>
